var render, staticRenderFns
import script from "./peer-rating-radar-chart.ts?vue&type=script&lang=ts&external"
export * from "./peer-rating-radar-chart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports